import type {
	ToastMessage
} from "~/types/utility";
import {
	useActiveToastMessage
} from "~/composables/utilityStores";
import {
	useDateFormat
} from "@vueuse/core";
import {
	useToast
} from "primevue";
import type {
	ToastMessageOptions
} from "primevue";

export const useUtils = () => {
	const { weddingDateDisplay } = weddingDateStores();
	const activeToastMessage = useActiveToastMessage();
	const toast = useToast();

	const openURL = async ( url: string ) => {
		await navigateTo( url, {
			external: true,
			open: {
				target: "_blank"
			}
		} );
	};

	const formatDate = ( formatString: string ) => useDateFormat( weddingDateDisplay.value, formatString );

	/**
	 * Displays a toast message with the provided details.
	 * @function showToastMessage
	 * @param {ToastMessage} messageDetails - The details of the toast message to be displayed.
	 * @returns {void}
	 */
	function showToastMessage( messageDetails: ToastMessage ): void {
		activeToastMessage.value = messageDetails;
		toast.add( messageDetails );
	}

	/**
	 * Hides the currently active toast message.
	 * This function removes all toast messages from the display.
	 * @function hideToastMessage
	 * @returns {void}
	 */
	function hideToastMessage( message: ToastMessageOptions ): void {
		toast.remove( message );
	}

	return {
		openURL,
		formatDate,
		showToastMessage,
		hideToastMessage
	};
};